import React from 'react';

const TradeMission = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Trade & Investment Mission</h1>
        <p>Exploring investment opportunities across Africa</p>
      </section>
      <section className="page-content">
        <div className="container">
          <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#E6D88A'}}>
            Our trade missions facilitate business connections, market entry strategies, 
            and investment partnerships between African businesses and global investors.
          </p>
          <div className="content-grid" style={{marginTop: '30px'}}>
            <div className="content-card">
              <h3>Market Research</h3>
              <p>In-depth analysis of target markets.</p>
            </div>
            <div className="content-card">
              <h3>Business Matching</h3>
              <p>Connect with potential partners and investors.</p>
            </div>
            <div className="content-card">
              <h3>On-the-Ground Support</h3>
              <p>Local expertise and logistical assistance.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TradeMission;